import React, { Fragment } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import { withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { QRCodeSVG } from "qrcode.react";

import BtclargeButton from "../assets/images/lg-button-BTC.png";
import BTCmediumButton from "../assets/images/md-button-BTC.png";
import BTCsmallButton from "../assets/images/sm-button-BTC.png";
import BTClargeButton from "../assets/images/lg-button-BCH.png";
import BCHmediumButton from "../assets/images/md-button-BCH.png";
import BCHsmallButton from "../assets/images/sm-button-BCH.png";
import LTClargeButton from "../assets/images/lg-button-LTC.png";
import LTCmediumButton from "../assets/images/md-button-LTC.png";
import LTCsmallButton from "../assets/images/sm-button-LTC.png";
import ETHlargeButton from "../assets/images/lg-button-ETH.png";
import ETHmediumButton from "../assets/images/md-button-ETH.png";
import ETHsmallButton from "../assets/images/sm-button-ETH.png";
import { SITENAMEALIAS, ASSETS, FILEPATH } from "../utils/init";
import {
  GetMerchantSettings,
  GetMarketPrice,
  FetchUsdBtcLedgerAmount,
  FetchMerchantSettings,
} from "../utils/service";
import {
  showToast,
  handleCurrencyDetiails,
  handleDynamicCurrencyDetiails,
  handleNetworkDetails,
  initialiseNetwork,
  _isOnlyNumber,
  showHttpError,
  showConfirm,
  currentPageAccess,
  getCurrencyWiseTxnCharge,
} from "../utils/library";

const styles = {
  pageWrapper: { padding: "32px 24px 60px" },
  backRow: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    marginBottom: "28px",
  },
  backBtn: {
    width: "38px",
    height: "38px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color-less)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    color: "var(--text-color)",
    fontSize: "15px",
  },
  pageTitle: {
    fontSize: "24px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
  },
  pageSubtitle: { fontSize: "13px", opacity: 0.5, margin: "4px 0 0" },
  card: {
    background: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid color-mix(in srgb, var(--text-color), transparent 92%)",
    marginBottom: "24px",
    overflow: "hidden",
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "20px 24px",
    borderBottom:
      "1px solid color-mix(in srgb, var(--text-color), transparent 92%)",
  },
  cardHeaderIcon: {
    width: "36px",
    height: "36px",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "15px",
    flexShrink: 0,
  },
  iconGreen: {
    color: "#10b981",
    background: "color-mix(in srgb, #10b981, transparent 88%)",
  },
  iconBlue: {
    color: "#3b82f6",
    background: "color-mix(in srgb, #3b82f6, transparent 88%)",
  },
  iconPurple: {
    color: "#7c3aed",
    background: "color-mix(in srgb, #7c3aed, transparent 88%)",
  },
  iconAmber: {
    color: "#f59e0b",
    background: "color-mix(in srgb, #f59e0b, transparent 88%)",
  },
  iconTeal: {
    color: "#14b8a6",
    background: "color-mix(in srgb, #14b8a6, transparent 88%)",
  },
  cardTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "var(--text-color)",
    margin: 0,
  },
  cardSubtitle: {
    fontSize: "12px",
    color: "var(--text-color)",
    opacity: 0.5,
    margin: 0,
  },
  cardBody: { padding: "24px" },
  formGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "20px",
    marginBottom: "20px",
  },
  formGroup: { display: "flex", flexDirection: "column", gap: "8px" },
  formLabel: {
    fontSize: "12px",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    color: "var(--text-color)",
    opacity: 0.6,
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  formInput: {
    padding: "11px 16px",
    borderRadius: "10px",
    border: "1px solid color-mix(in srgb, var(--text-color), transparent 85%)",
    background: "var(--body-color-less2)",
    color: "var(--text-color)",
    fontSize: "14px",
    outline: "none",
    transition: "border-color 0.2s ease",
    width: "100%",
    boxSizing: "border-box",
  },
  formSelect: {
    padding: "11px 16px",
    borderRadius: "10px",
    border: "1px solid color-mix(in srgb, var(--text-color), transparent 85%)",
    background: "var(--body-color-less2)",
    color: "var(--text-color)",
    fontSize: "14px",
    outline: "none",
    transition: "border-color 0.2s ease",
    width: "100%",
    boxSizing: "border-box",
    cursor: "pointer",
  },
  disabledInput: {
    padding: "11px 16px",
    borderRadius: "10px",
    border: "1px solid color-mix(in srgb, var(--text-color), transparent 90%)",
    background: "color-mix(in srgb, var(--body-color-less2), transparent 40%)",
    color: "var(--text-color)",
    fontSize: "14px",
    fontFamily: "'SF Mono', 'Fira Code', 'Fira Mono', monospace",
    opacity: 0.7,
    width: "100%",
    boxSizing: "border-box",
  },
  tooltipIcon: { fontSize: "12px", color: "var(--btn-color)", cursor: "help" },
  buttonSizeOptions: { display: "flex", gap: "10px", flexWrap: "wrap" },
  sizeBtn: {
    padding: "8px 18px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    fontSize: "12px",
    fontWeight: "600",
    cursor: "pointer",
  },
  sizeBtnActive: {
    padding: "8px 18px",
    borderRadius: "10px",
    border: "1px solid var(--btn-color)",
    background:
      "linear-gradient(135deg, color-mix(in srgb, var(--btn-color) 12%, transparent), color-mix(in srgb, var(--btn-color) 4%, transparent))",
    color: "var(--btn-color)",
    fontSize: "12px",
    fontWeight: "600",
    cursor: "pointer",
  },
  sectionDivider: {
    borderTop: "1px solid var(--body-color-less2)",
    margin: "8px 0",
  },
  tabContainer: {
    display: "flex",
    background: "var(--body-color)",
    borderRadius: "12px",
    padding: "4px",
    border: "1px solid var(--body-color-less2)",
    marginBottom: "16px",
    gap: "4px",
  },
  tab: {
    flex: 1,
    padding: "10px 16px",
    borderRadius: "9px",
    border: "none",
    background: "transparent",
    color: "var(--text-color)",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    transition: "all 0.2s ease",
    opacity: 0.6,
  },
  tabActive: {
    flex: 1,
    padding: "10px 16px",
    borderRadius: "9px",
    border: "none",
    background: "var(--btn-color)",
    color: "#fff",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  },
  tabContent: { padding: "16px 0 0" },
  divider: {
    height: "1px",
    background: "color-mix(in srgb, var(--text-color), transparent 92%)",
    margin: "24px 0",
  },
  paymentLinkCard: {
    background: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid color-mix(in srgb, var(--text-color), transparent 92%)",
    marginBottom: "24px",
    padding: "24px",
  },
  paymentLinkHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "16px",
  },
  linkRow: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "4px",
    borderRadius: "12px",
    background: "var(--body-color-less2)",
    border: "1px solid color-mix(in srgb, var(--text-color), transparent 90%)",
  },
  linkInput: {
    flex: 1,
    padding: "10px 14px",
    border: "none",
    background: "transparent",
    fontFamily: "'SF Mono', 'Fira Code', 'Fira Mono', monospace",
    fontSize: "12px",
    color: "var(--text-color)",
    outline: "none",
    minWidth: 0,
  },
  copyBtn: {
    padding: "7px 16px",
    borderRadius: "8px",
    border: "1px solid var(--btn-color)",
    background: "transparent",
    color: "var(--btn-color)",
    fontSize: "12px",
    fontWeight: "600",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
  },
  copyBtnDisabled: {
    padding: "7px 16px",
    borderRadius: "8px",
    border: "1px solid var(--body-color-less2)",
    background: "transparent",
    color: "var(--text-color)",
    opacity: 0.4,
    fontSize: "12px",
    fontWeight: "600",
    cursor: "not-allowed",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
  },
  codeArea: {
    width: "100%",
    minHeight: "120px",
    padding: "14px 16px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    fontSize: "12px",
    fontFamily: "'SF Mono', 'Fira Code', monospace",
    resize: "vertical",
    outline: "none",
    boxSizing: "border-box",
  },
  previewBox: {
    padding: "24px",
    borderRadius: "10px",
    border: "1px dashed var(--body-color-less2)",
    background: "var(--body-color)",
    textAlign: "center",
    minHeight: "80px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  previewPlaceholder: {
    fontSize: "13px",
    color: "var(--text-color)",
    opacity: 0.4,
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0,0,0,0.6)",
    backdropFilter: "blur(6px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1060,
    padding: "20px",
  },
  modalContent: {
    background: "var(--body-color-less)",
    borderRadius: "20px",
    width: "100%",
    maxWidth: "480px",
    border: "1px solid color-mix(in srgb, var(--text-color), transparent 90%)",
    boxShadow: "0 24px 80px rgba(0,0,0,0.3)",
    overflow: "hidden",
  },
  modalHeader: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    padding: "24px 28px 20px",
    borderBottom:
      "1px solid color-mix(in srgb, var(--text-color), transparent 92%)",
  },
  modalIconBadge: {
    width: "42px",
    height: "42px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "18px",
    color: "#f59e0b",
    background: "color-mix(in srgb, #f59e0b, transparent 88%)",
    flexShrink: 0,
  },
  modalTitle: {
    fontSize: "18px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
  },
  modalSubtitle: {
    fontSize: "13px",
    color: "var(--text-color)",
    opacity: 0.5,
    margin: 0,
  },
  modalBody: { padding: "24px 28px" },
  modalBodyTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "var(--text-color)",
    marginBottom: "12px",
    lineHeight: 1.4,
  },
  modalBodyText: {
    fontSize: "14px",
    color: "var(--text-color)",
    opacity: 0.7,
    lineHeight: 1.6,
  },
  modalFooter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "12px",
    padding: "20px 28px 24px",
    borderTop:
      "1px solid color-mix(in srgb, var(--text-color), transparent 92%)",
  },
  btnPrimary: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px 24px",
    borderRadius: "12px",
    border: "none",
    background: "var(--btn-color)",
    color: "#fff",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    boxShadow:
      "0 2px 8px color-mix(in srgb, var(--btn-color), transparent 60%)",
  },
  btnCancel: {
    padding: "10px 24px",
    borderRadius: "12px",
    border: "1px solid color-mix(in srgb, var(--text-color), transparent 85%)",
    background: "transparent",
    color: "var(--text-color)",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
  },
};

class PaymentButtons extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      isTermsChecked: false,
      selectedAsset: {},
      buttonHtml: "",
      showPreview: false,
      buttonImageUrl: "",
      previewFormAction: "",
      encodedValue: "",
      selectedQty: 1,
      selectedButtonSize: "",
      convertedPriceAndCurreny: "",
      convertedPrice: "",
      networkArray: [],
      assets: [],
      network: "",
      permission: "",
      showToleranceModal: false,
      selectedCode: "",
      activeGenerateTab: "button",
      showPreviewForButton: false,
      showPreviewForHyperlink: false,
      showPreviewForQrCode: false,
      qrCodeLink: "",
      processingFeeHandling: "customer",
      // ── txn charge for selected currency ──
      txnCharge: null,
    };

    this.priceRef = React.createRef();
    this.cryptoPriceRef = React.createRef();
    this.currencyRef = React.createRef();
    this.descriptionRef = React.createRef();
    this.descriptionDebounceTimer = null;
  }

  renderMerchantProcessingFeeType = async () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });

    FetchMerchantSettings(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            let processingFeesType = response.is_processing_fee_enabled;
            this.setState({
              processingFeeHandling:
                parseInt(processingFeesType) === 1 ? "customer" : "merchant",
            });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          console.log("err", err);
          showHttpError(err);
        }.bind(this)
      );
  };

  openToleranceModal = (code) => {
    this.setState({ showToleranceModal: true, selectedCode: code });
  };

  handleClose = () => {
    this.setState({ showToleranceModal: false });
  };

  handleConfirm = () => {
    const { selectedCode } = this.state;
    localStorage.setItem(SITENAMEALIAS + "_need_tolerance_setting", "true");
    localStorage.setItem(
      SITENAMEALIAS + "_need_tolerance_setting_for_currency",
      selectedCode
    );
    this.setState({ showToleranceModal: false }, () => {
      this.props.history.push("/settings");
    });
  };

  // ── Fetch txn charge for the given asset code and store in state ──
  fetchTxnCharge = async (assetCode) => {
    const charge = await getCurrencyWiseTxnCharge(assetCode);
    this.setState({ txnCharge: charge });
  };

  handleSelectedCurrency = (e) => {
    let code = e.target.value;
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      currency_id: code,
    };
    this.setState({ showLoader: true });
    GetMerchantSettings(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            if (
              response.accept_overpayments != "" &&
              response.accept_overpayments != null &&
              response.accept_overpayments != "no" &&
              response.accept_underpayments != "" &&
              response.accept_underpayments != null &&
              response.accept_underpayments != "no"
            ) {
              const newAsset = handleDynamicCurrencyDetiails(
                this.state.assets,
                code
              );
              this.setState(
                {
                  selectedAsset: newAsset,
                  networkArray: newAsset.network,
                  network: initialiseNetwork(code),
                  convertedPriceAndCurreny: "",
                  convertedPrice: "",
                  buttonHtml: "",
                  encodedValue: "",
                  previewFormAction: "",
                  showPreviewForButton: false,
                  showPreviewForHyperlink: false,
                  showPreviewForQrCode: false,
                },
                () => {
                  this.getConvertedPrice();
                  // ── Refresh txn charge for newly selected currency ──
                  this.fetchTxnCharge(newAsset.assetCode);
                }
              );
            } else {
              this.openToleranceModal(code);
            }
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  handleNetworkChange = (e) => {
    this.setState({ network: e.target.value }, () => {
      this.autoRegeneratePaymentLink();
    });
  };

  autoRegeneratePaymentLink = () => {
    if (
      this.priceRef.current &&
      this.priceRef.current.value !== "" &&
      this.descriptionRef.current &&
      this.descriptionRef.current.value !== "" &&
      this.state.selectedAsset.assetId &&
      this.state.convertedPrice &&
      this.state.permission === "WRITE"
    ) {
      this.handleGenerateButton(this.state.selectedButtonSize || "medium");
    }
  };

  copyCodeToClipboard = () => {
    const el = this.textArea;
    el.select();
    document.execCommand("copy");
    showToast("success", " Successfully copied to clipboard");
  };

  copyLinkToClipboard = () => {
    const link = this.getPaymentLink();
    navigator.clipboard
      .writeText(link)
      .then(() => {
        showToast("success", "Payment link copied to clipboard");
      })
      .catch(() => {
        const tempInput = document.createElement("input");
        tempInput.value = link;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);
        showToast("success", "Payment link copied to clipboard");
      });
  };

  getPaymentLink = () => {
    return (
      this.state.previewFormAction +
      "?data=" +
      this.state.encodedValue +
      "&quantity=" +
      this.state.selectedQty
    );
  };

  generateHyperLink = () => {
    if (this.state.showPreview) {
      let link = this.getPaymentLink();
      let html = '<a href="' + link + '" target="_blank">Order Now</a>';
      this.setState({
        buttonHtml: html,
        showPreviewForButton: false,
        showPreviewForHyperlink: true,
        showPreviewForQrCode: false,
      });
    } else {
      showToast(
        "error",
        "Please provide price, currency and description first"
      );
    }
  };

  generateQrCode = () => {
    if (this.state.showPreview) {
      let url = this.getPaymentLink();
      this.setState(
        {
          buttonHtml: "",
          qrCodeLink: url,
          showPreviewForButton: false,
          showPreviewForHyperlink: false,
          showPreviewForQrCode: true,
        },
        () => {
          let element = document.getElementById("qrCodeHtml").innerHTML;
          this.setState({ buttonHtml: element });
        }
      );
    } else {
      showToast(
        "error",
        "Please provide price, currency and description first"
      );
    }
  };

  handleGenerateButton = (size) => {
    if (this.state.permission == "WRITE") {
      if (
        this.priceRef.current.value != "" &&
        this.currencyRef.current.value != "" &&
        this.descriptionRef.current.value != ""
      ) {
        let code_obj = {};
        code_obj["merchant_id"] = localStorage.getItem(
          SITENAMEALIAS + "_merchant_id"
        );
        code_obj["currency_id"] = this.state.selectedAsset.assetId;
        code_obj["currency"] = this.state.selectedAsset.assetCode;
        code_obj["amount"] = this.state.convertedPrice;
        code_obj["fiat_amount"] = this.priceRef.current.value;
        code_obj["description"] = this.descriptionRef.current.value;
        code_obj["button_size"] = size;
        code_obj["network"] = this.state.network;
        code_obj["is_processing_fee_applied"] =
          this.state.processingFeeHandling === "customer" ? 1 : 0;
        code_obj["brokerId"] =
          localStorage.getItem(SITENAMEALIAS + "_brokerId") ||
          localStorage.getItem(SITENAMEALIAS + "_brokerId") ||
          "";
        console.log(
          "Here => ",
          this.state.processingFeeHandling,
          code_obj["is_processing_fee_applied"]
        );
        let code_JSON = JSON.stringify(code_obj);
        let encrypted_code_JSON = btoa(code_JSON);
        let imageText = "",
          buttonStyle = "",
          buttonImageStyle = "",
          buttonTextStyle = "";
        if (size == "small") {
          imageText = "sm-button-";
          buttonStyle = "width:80px;height:43px;";
          buttonImageStyle = "width:16px;";
          buttonTextStyle = "font-size:10px;";
        } else if (size == "medium") {
          imageText = "md-button-";
          buttonStyle = "width:105px;height:56px;";
          buttonImageStyle = "width:33px;";
          buttonTextStyle = "font-size:12px;";
        } else {
          imageText = "lg-button-";
          buttonStyle = "width:132px;height:70px;";
          buttonImageStyle = "width:40px;";
          buttonTextStyle = "font-size:12px;";
        }
        let html = "";
        html +=
          ' <div style="display:block;" id="paynow_button_form_container">';
        html +=
          '<form method="GET" action="' +
          window.location.origin +
          '/merchant/init-payment2.html" target="_blank">';
        html +=
          '<input type="hidden" name="data" value="' +
          encrypted_code_JSON +
          '"/>';
        html += '<table border="0"><tbody><tr>';
        html +=
          '<td style="padding:5px;" align="center" valign="middle"><label>Qty:</label></td>';
        html +=
          '<td style="padding:5px;" align="center" valign="middle"><input min="1" required name="quantity" type="number" value="' +
          this.state.selectedQty +
          '" style="border-radius:4px; border:1px solid #ccc; height:42px; width:60px; padding:6px; " /></td>';
        html +=
          '<td style="padding:5px;" align="center" valign="middle"><button style="padding:0; border:0;background : #102ab3;color:#fff; ' +
          buttonStyle +
          '" type="submit" ><img  src="' +
          this.assetDetailsForButtons(this.state.selectedAsset.assetId)
            .assetImage +
          '" style="' +
          buttonImageStyle +
          '"/> <span style="' +
          buttonTextStyle +
          '">Buy Now</span></button></td>';
        html += "</tr></tbody></table></form></div>";
        this.setState({
          buttonHtml: html,
          showPreview: true,
          selectedButtonSize: size,
          showPreviewForButton: true,
          showPreviewForHyperlink: false,
          showPreviewForQrCode: false,
          buttonImageUrl:
            FILEPATH +
            "/" +
            imageText +
            this.state.selectedAsset.assetCode +
            ".png",
          encodedValue: encrypted_code_JSON,
          previewFormAction:
            window.location.origin + "/merchant/init-payment2.html",
        });
      } else {
        showToast("error", "Please provide price, currency and description");
      }
    } else {
      showToast("error", "You need write access to perform this operation");
    }
  };

  getConvertedPrice = () => {
    let currency = this.state.selectedAsset.assetCode;
    this.setState({ showLoader: true });
    GetMarketPrice(currency)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data;
          let price = response.price;
          let convertedPrice =
            parseFloat(this.priceRef.current.value) / parseFloat(price);
          this.setState(
            {
              convertedPriceAndCurreny:
                convertedPrice.toFixed(6) + " " + currency,
              convertedPrice: convertedPrice.toFixed(6),
            },
            () => {
              this.autoRegeneratePaymentLink();
            }
          );
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
        }.bind(this)
      );
  };

  handleRenderAssets = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });
    FetchUsdBtcLedgerAmount(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            if (response != undefined && response != null) {
              let coinBalance = response.coin_balance;
              let arr = [];
              if (coinBalance != undefined) {
                for (let i = 0; i < coinBalance.length; i++) {
                  if (coinBalance[i].currency_code != "USD") {
                    let obj = {
                      assetName: coinBalance[i].currency_name,
                      coinBalance: coinBalance[i].balance,
                      assetCode: coinBalance[i].currency_code,
                      assetId: coinBalance[i].currency_id,
                      assetImage: coinBalance[i].logo,
                      network: coinBalance[i].network,
                      isBrokerCurrency: coinBalance[i].is_broker_currency,
                    };
                    arr.push(obj);
                  }
                }
              }
              const currencyOrder = [
                "USDC",
                "USDT",
                "XRP",
                "DOGE",
                "HCX",
                "ETH",
                "BTC",
                "LTC",
                "BCH",
              ];
              arr.sort((a, b) => {
                const idxA = currencyOrder.indexOf(a.assetCode);
                const idxB = currencyOrder.indexOf(b.assetCode);
                return (idxA === -1 ? 999 : idxA) - (idxB === -1 ? 999 : idxB);
              });
              this.setState({ assets: arr }, () => {
                localStorage.setItem(
                  SITENAMEALIAS + "_assets",
                  JSON.stringify(this.state.assets)
                );
              });
            }
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  assetDetailsForButtons = (assetId) => {
    let assets = this.state.assets;
    let result = {};
    for (let i = 0; i < assets.length; i++) {
      if (assetId == assets[i].assetId) {
        result = assets[i];
        break;
      }
    }
    return result;
  };

  componentDidMount() {
    this.renderMerchantProcessingFeeType();
    this.setState({ permission: currentPageAccess() });
    this.handleRenderAssets();
    let byDefaultCurrencyId = 148;
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      currency_id: byDefaultCurrencyId,
    };
    const defaultAsset = handleCurrencyDetiails(byDefaultCurrencyId);
    this.setState(
      {
        selectedAsset: defaultAsset,
        networkArray: handleNetworkDetails(byDefaultCurrencyId),
        network: initialiseNetwork(byDefaultCurrencyId),
      },
      () => {
        this.priceRef.current.value = 1;
        this.getConvertedPrice();
        // ── Fetch txn charge for default currency on mount ──
        this.fetchTxnCharge(defaultAsset.assetCode);
      }
    );
    this.setState({ showLoader: true });
    GetMerchantSettings(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            if (
              response.accept_overpayments != "" &&
              response.accept_overpayments != null &&
              response.accept_overpayments != "no" &&
              response.accept_underpayments != "" &&
              response.accept_underpayments != null &&
              response.accept_underpayments != "no"
            ) {
            } else {
              this.openToleranceModal(byDefaultCurrencyId);
            }
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  }

  render() {
    const { processingFeeHandling, txnCharge, selectedAsset } = this.state;

    // ── Fee description strings ──
    const feeLabel =
      txnCharge != null ? `A ${txnCharge} fee` : "The processing fee";
    const currencyLabel = selectedAsset.assetCode
      ? ` for ${selectedAsset.assetCode}`
      : "";

    const optionStyleFor = (val) => ({
      flex: 1,
      display: "flex",
      alignItems: "flex-start",
      gap: "14px",
      padding: "16px 20px",
      borderRadius: "12px",
      margin: 0,
      border:
        processingFeeHandling === val
          ? "2px solid var(--btn-color)"
          : "2px solid color-mix(in srgb, var(--text-color), transparent 88%)",
      background:
        processingFeeHandling === val
          ? "color-mix(in srgb, var(--btn-color), transparent 94%)"
          : "var(--body-color)",
      cursor: "pointer",
      transition: "all 0.2s ease",
      userSelect: "none",
    });

    const radioDotFor = (val) => ({
      width: "18px",
      height: "18px",
      borderRadius: "50%",
      background: "var(--body-color)",
      transition: "all 0.2s ease",
      border:
        processingFeeHandling === val
          ? "5px solid var(--btn-color)"
          : "2px solid color-mix(in srgb, var(--text-color), transparent 60%)",
    });

    return (
      <Fragment>
        <div className="container-scroller">
          <Sidebar />
          <Header />
          <div className="main-panel">
            <div style={styles.pageWrapper}>
              {/* Back + Title */}
              <div style={styles.backRow}>
                <div
                  style={styles.backBtn}
                  onClick={() => this.props.history.push("/payments")}
                >
                  <FontAwesomeIcon icon={faArrowLeft} />
                </div>
                <div>
                  <h2 style={styles.pageTitle}>Create a Payment Link</h2>
                  <div style={styles.pageSubtitle}>
                    Create checkout buttons and payment links for your website
                  </div>
                </div>
              </div>

              {/* Create Checkout Button Card */}
              <div style={styles.card}>
                <div style={styles.cardHeader}>
                  <div
                    style={{ ...styles.cardHeaderIcon, ...styles.iconGreen }}
                  >
                    <i className="fa fa-plus-circle"></i>
                  </div>
                  <div>
                    <h5 style={styles.cardTitle}>Create a payment link</h5>
                    <p style={styles.cardSubtitle}>
                      Configure your payment details and generate embed code
                    </p>
                  </div>
                </div>
                <div style={styles.cardBody}>
                  <div style={styles.formGrid}>
                    <div style={styles.formGroup}>
                      <label style={styles.formLabel}>USD Price</label>
                      <input
                        type="number"
                        style={styles.formInput}
                        defaultValue={1}
                        ref={this.priceRef}
                        onChange={(e) => {
                          this.priceRef.current.value = e.target.value;
                          setTimeout(() => {
                            if (this.priceRef.current.value != "")
                              this.getConvertedPrice();
                          }, 1000);
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "var(--btn-color)";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor =
                            "color-mix(in srgb, var(--text-color), transparent 85%)";
                        }}
                      />
                    </div>
                    <div style={styles.formGroup}>
                      <label style={styles.formLabel}>
                        Crypto Price
                        <span className="tooltip-container">
                          <i
                            className="fa fa-info-circle"
                            style={styles.tooltipIcon}
                          ></i>
                          <span className="tooltip-text">
                            The crypto amount shown here is an estimate. At the
                            time of payment, the system will automatically check
                            the current market price and charge the customer the
                            equivalent amount.
                          </span>
                        </span>
                      </label>
                      <input
                        type="text"
                        style={styles.disabledInput}
                        value={this.state.convertedPriceAndCurreny}
                        disabled
                        placeholder="Select currency"
                      />
                    </div>
                    <div style={styles.formGroup}>
                      <label style={styles.formLabel}>Currency</label>
                      <select
                        style={styles.formSelect}
                        ref={this.currencyRef}
                        onChange={(e) => this.handleSelectedCurrency(e)}
                      >
                        {this.state.assets.map((item) => (
                          <option key={item.assetId} value={item.assetId}>
                            {item.assetCode} - {item.assetName}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div style={styles.formGroup}>
                      <label style={styles.formLabel}>Network</label>
                      {this.state.networkArray.length > 1 ? (
                        <select
                          style={styles.formSelect}
                          ref={this.networkRef}
                          onChange={(e) => this.handleNetworkChange(e)}
                        >
                          {this.state.networkArray.map((network) => (
                            <option key={network} value={network}>
                              {network}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <input
                          type="text"
                          style={styles.formSelect}
                          value={this.state.networkArray[0] || ""}
                          disabled
                        />
                      )}
                    </div>
                  </div>

                  <div style={{ ...styles.formGroup, marginBottom: "20px" }}>
                    <label style={styles.formLabel}>Description</label>
                    <input
                      type="text"
                      style={styles.formInput}
                      placeholder="Enter a description for this payment"
                      ref={this.descriptionRef}
                      onChange={() => {
                        if (this.descriptionDebounceTimer) {
                          clearTimeout(this.descriptionDebounceTimer);
                        }
                        this.descriptionDebounceTimer = setTimeout(() => {
                          this.autoRegeneratePaymentLink();
                        }, 300);
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = "var(--btn-color)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor =
                          "color-mix(in srgb, var(--text-color), transparent 85%)";
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* ── Processing Fee Handling Card ── */}
              <div style={styles.card}>
                <div style={styles.cardHeader}>
                  <div style={{ ...styles.cardHeaderIcon, ...styles.iconTeal }}>
                    <i className="fa fa-percent"></i>
                  </div>
                  <div>
                    <h5 style={styles.cardTitle}>Processing Fee Handling</h5>
                    <p style={styles.cardSubtitle}>
                      Choose how transaction fees are applied for this payment.
                    </p>
                  </div>
                </div>
                <div style={styles.cardBody}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "12px",
                    }}
                  >
                    {/* Option 1 — Customer pays */}
                    <label
                      onClick={() =>
                        this.setState(
                          { processingFeeHandling: "customer" },
                          () => {
                            this.handleGenerateButton(
                              this.state.selectedButtonSize
                            );
                          }
                        )
                      }
                      style={optionStyleFor("customer")}
                    >
                      <div style={{ paddingTop: "2px", flexShrink: 0 }}>
                        <div style={radioDotFor("customer")} />
                      </div>
                      <div>
                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "var(--text-color)",
                            marginBottom: "3px",
                          }}
                        >
                          The customer pays the processing fee
                        </div>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "var(--text-color)",
                            opacity: 0.55,
                            lineHeight: 1.4,
                          }}
                        >
                          {feeLabel}
                          {currencyLabel} will be added to the checkout total.
                        </div>
                      </div>
                    </label>

                    {/* Option 2 — Merchant absorbs */}
                    <label
                      onClick={() =>
                        this.setState(
                          { processingFeeHandling: "merchant" },
                          () => {
                            this.handleGenerateButton(
                              this.state.selectedButtonSize
                            );
                          }
                        )
                      }
                      style={optionStyleFor("merchant")}
                    >
                      <div style={{ paddingTop: "2px", flexShrink: 0 }}>
                        <div style={radioDotFor("merchant")} />
                      </div>
                      <div>
                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "var(--text-color)",
                            marginBottom: "3px",
                          }}
                        >
                          Merchant absorbs the processing fee
                        </div>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "var(--text-color)",
                            opacity: 0.55,
                            lineHeight: 1.4,
                          }}
                        >
                          {feeLabel}
                          {currencyLabel} will be deducted from your payout.
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              {/* ── End Processing Fee Handling Card ── */}

              {/* Payment Link - Outside Card */}
              <div style={styles.paymentLinkCard}>
                <div style={styles.paymentLinkHeader}>
                  <div
                    style={{ ...styles.cardHeaderIcon, ...styles.iconAmber }}
                  >
                    <i className="fa fa-link"></i>
                  </div>
                  <h5 style={styles.cardTitle}>Payment Link</h5>
                </div>
                <div style={styles.linkRow}>
                  <input
                    type="text"
                    style={styles.linkInput}
                    value={this.state.encodedValue ? this.getPaymentLink() : ""}
                    readOnly
                    placeholder="Fill in the details above to generate a payment link"
                  />
                  <button
                    style={
                      this.state.encodedValue
                        ? styles.copyBtn
                        : styles.copyBtnDisabled
                    }
                    onClick={() =>
                      this.state.encodedValue && this.copyLinkToClipboard()
                    }
                    disabled={!this.state.encodedValue}
                  >
                    <i className="fa fa-copy" style={{ fontSize: "12px" }}></i>
                    Copy
                  </button>
                  <button
                    style={
                      this.state.encodedValue
                        ? styles.copyBtn
                        : styles.copyBtnDisabled
                    }
                    onClick={() =>
                      this.state.encodedValue &&
                      window.open(this.getPaymentLink(), "_blank")
                    }
                    disabled={!this.state.encodedValue}
                  >
                    <i
                      className="fa fa-external-link"
                      style={{ fontSize: "12px" }}
                    ></i>
                    Open
                  </button>
                </div>
              </div>

              {/* Button Code Card */}
              <div style={styles.card}>
                <div style={styles.cardHeader}>
                  <div
                    style={{ ...styles.cardHeaderIcon, ...styles.iconPurple }}
                  >
                    <i className="fa fa-code"></i>
                  </div>
                  <h5 style={styles.cardTitle}>Button Code</h5>
                </div>
                <div style={styles.cardBody}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "16px",
                    }}
                  >
                    <label style={{ ...styles.formLabel, margin: 0 }}>
                      Generated HTML Code
                    </label>
                    <button
                      type="button"
                      style={styles.copyBtn}
                      onClick={() => this.copyCodeToClipboard()}
                    >
                      <i className="fa fa-copy" /> Copy Code
                    </button>
                  </div>

                  <div style={styles.tabContainer}>
                    <button
                      type="button"
                      style={
                        this.state.activeGenerateTab === "button"
                          ? styles.tabActive
                          : styles.tab
                      }
                      onClick={() =>
                        this.setState({ activeGenerateTab: "button" })
                      }
                    >
                      <i className="mdi mdi-gesture-tap-button" /> Button
                    </button>
                    <button
                      type="button"
                      style={
                        this.state.activeGenerateTab === "qrcode"
                          ? styles.tabActive
                          : styles.tab
                      }
                      onClick={() =>
                        this.setState({ activeGenerateTab: "qrcode" })
                      }
                    >
                      <i className="mdi mdi-qrcode" /> QR Code
                    </button>
                    <button
                      type="button"
                      style={
                        this.state.activeGenerateTab === "hyperlink"
                          ? styles.tabActive
                          : styles.tab
                      }
                      onClick={() =>
                        this.setState({ activeGenerateTab: "hyperlink" })
                      }
                    >
                      <i className="mdi mdi-link" /> Hyperlink
                    </button>
                  </div>

                  <div style={styles.tabContent}>
                    {this.state.activeGenerateTab === "button" && (
                      <div>
                        <label
                          style={{
                            ...styles.formLabel,
                            marginBottom: "10px",
                            display: "block",
                          }}
                        >
                          Select Button Size
                        </label>
                        <div style={styles.buttonSizeOptions}>
                          <button
                            type="button"
                            style={
                              this.state.selectedButtonSize === "small"
                                ? styles.sizeBtnActive
                                : styles.sizeBtn
                            }
                            onClick={() => this.handleGenerateButton("small")}
                          >
                            <i
                              className="mdi mdi-checkbox-blank-outline"
                              style={{ fontSize: "11px" }}
                            />{" "}
                            80 x 43 px
                          </button>
                          <button
                            type="button"
                            style={
                              this.state.selectedButtonSize === "medium"
                                ? styles.sizeBtnActive
                                : styles.sizeBtn
                            }
                            onClick={() => this.handleGenerateButton("medium")}
                          >
                            <i
                              className="mdi mdi-checkbox-blank-outline"
                              style={{ fontSize: "13px" }}
                            />{" "}
                            105 x 56 px
                          </button>
                          <button
                            type="button"
                            style={
                              this.state.selectedButtonSize === "large"
                                ? styles.sizeBtnActive
                                : styles.sizeBtn
                            }
                            onClick={() => this.handleGenerateButton("large")}
                          >
                            <i
                              className="mdi mdi-checkbox-blank-outline"
                              style={{ fontSize: "15px" }}
                            />{" "}
                            132 x 70 px
                          </button>
                        </div>
                      </div>
                    )}
                    {this.state.activeGenerateTab === "qrcode" && (
                      <div style={{ textAlign: "center" }}>
                        <button
                          type="button"
                          style={{
                            ...styles.btnPrimary,
                            opacity: this.state.showPreview ? 1 : 0.5,
                            cursor: this.state.showPreview
                              ? "pointer"
                              : "not-allowed",
                          }}
                          onClick={() => this.generateQrCode()}
                          disabled={!this.state.showPreview}
                        >
                          <i className="mdi mdi-qrcode" /> Generate QR Code
                        </button>
                      </div>
                    )}
                    {this.state.activeGenerateTab === "hyperlink" && (
                      <div style={{ textAlign: "center" }}>
                        <button
                          type="button"
                          style={{
                            ...styles.btnPrimary,
                            opacity: this.state.showPreview ? 1 : 0.5,
                            cursor: this.state.showPreview
                              ? "pointer"
                              : "not-allowed",
                          }}
                          onClick={() => this.generateHyperLink()}
                          disabled={!this.state.showPreview}
                        >
                          <i className="mdi mdi-link" /> Generate Hyperlink
                        </button>
                      </div>
                    )}
                  </div>

                  <div
                    style={{ ...styles.sectionDivider, margin: "20px 0 16px" }}
                  />

                  <div
                    style={{
                      fontSize: "12px",
                      color: "var(--text-color)",
                      opacity: 0.5,
                      marginBottom: "8px",
                    }}
                  >
                    Select all of the HTML code below, then copy and paste it
                    into your webpage.
                  </div>
                  <textarea
                    style={styles.codeArea}
                    ref={(textarea) => (this.textArea = textarea)}
                    value={this.state.buttonHtml}
                    readOnly
                  />

                  <div
                    style={{ ...styles.sectionDivider, margin: "20px 0 16px" }}
                  />

                  <div>
                    <label
                      style={{
                        ...styles.formLabel,
                        marginBottom: "10px",
                        display: "block",
                      }}
                    >
                      Preview
                    </label>
                    <div style={styles.previewBox}>
                      {!this.state.showPreviewForButton &&
                        !this.state.showPreviewForHyperlink &&
                        !this.state.showPreviewForQrCode && (
                          <span style={styles.previewPlaceholder}>
                            Select a tab above and generate to see the preview
                          </span>
                        )}

                      {this.state.showPreviewForButton && (
                        <div id="paynow_button_form_container">
                          <form
                            method="GET"
                            action={this.state.previewFormAction}
                            target="_blank"
                          >
                            <input
                              type="hidden"
                              name="data"
                              value={this.state.encodedValue}
                            />
                            <table border="0">
                              <tbody>
                                <tr>
                                  <td
                                    style={{ padding: "5px" }}
                                    align="center"
                                    valign="middle"
                                  >
                                    <label>Qty:</label>
                                  </td>
                                  <td
                                    style={{ padding: "5px" }}
                                    align="center"
                                    valign="middle"
                                  >
                                    <input
                                      min="1"
                                      required
                                      name="quantity"
                                      type="number"
                                      value={this.state.selectedQty}
                                      onChange={(e) => {
                                        if (!isNaN(e.target.value)) {
                                          this.setState(
                                            { selectedQty: e.target.value },
                                            () => {
                                              this.handleGenerateButton(
                                                this.state.selectedButtonSize
                                              );
                                            }
                                          );
                                        }
                                      }}
                                      style={{
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                        height: "42px",
                                        width: "60px",
                                        padding: "6px",
                                      }}
                                    />
                                  </td>
                                  <td
                                    style={{ padding: "5px" }}
                                    align="center"
                                    valign="middle"
                                  >
                                    <button
                                      type="submit"
                                      style={
                                        this.state.selectedButtonSize ===
                                        "small"
                                          ? {
                                              borderRadius: "4px",
                                              border: "solid #fff",
                                              background: "#102ab3",
                                              color: "#fff",
                                              width: "80px",
                                              height: "43px",
                                            }
                                          : this.state.selectedButtonSize ===
                                            "large"
                                          ? {
                                              borderRadius: "4px",
                                              border: "solid #fff",
                                              background: "#102ab3",
                                              color: "#fff",
                                              width: "132px",
                                              height: "70px",
                                            }
                                          : {
                                              borderRadius: "4px",
                                              border: "solid #fff",
                                              background: "#102ab3",
                                              color: "#fff",
                                              width: "105px",
                                              height: "56px",
                                            }
                                      }
                                    >
                                      <img
                                        src={
                                          this.assetDetailsForButtons(
                                            this.state.selectedAsset.assetId
                                          ).assetImage
                                        }
                                        style={
                                          this.state.selectedButtonSize ===
                                          "small"
                                            ? { width: "16px" }
                                            : this.state.selectedButtonSize ===
                                              "large"
                                            ? { width: "40px" }
                                            : { width: "33px" }
                                        }
                                      />{" "}
                                      <span
                                        style={
                                          this.state.selectedButtonSize ===
                                          "small"
                                            ? { fontSize: "10px" }
                                            : { fontSize: "12px" }
                                        }
                                      >
                                        Buy Now
                                      </span>
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </form>
                        </div>
                      )}

                      {this.state.showPreviewForHyperlink && (
                        <div>
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={this.getPaymentLink()}
                            style={{
                              color: "var(--btn-color)",
                              fontWeight: "600",
                              fontSize: "14px",
                            }}
                          >
                            Order Now
                          </a>
                        </div>
                      )}

                      {this.state.showPreviewForQrCode && (
                        <div id="qrCodeHtml">
                          <QRCodeSVG value={this.state.qrCodeLink} />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
          <Loader show={this.state.showLoader} />

          {/* Tolerance Settings Modal */}
          {this.state.showToleranceModal && (
            <div style={styles.modalOverlay} onClick={this.handleClose}>
              <div
                style={styles.modalContent}
                onClick={(e) => e.stopPropagation()}
              >
                <div style={styles.modalHeader}>
                  <div style={styles.modalIconBadge}>
                    <i className="fa fa-wrench"></i>
                  </div>
                  <div>
                    <h5 style={styles.modalTitle}>Settings Required</h5>
                    <p style={styles.modalSubtitle}>
                      Configure tolerance limits before proceeding
                    </p>
                  </div>
                </div>
                <div style={styles.modalBody}>
                  <div style={styles.modalBodyTitle}>
                    Set your underpayment or overpayment tolerance limits
                  </div>
                  <div style={styles.modalBodyText}>
                    Navigate to{" "}
                    <strong>
                      Merchant Settings &gt; Automatic Exception Handling
                    </strong>
                  </div>
                </div>
                <div style={styles.modalFooter}>
                  <button
                    type="button"
                    style={styles.btnCancel}
                    onClick={this.handleClose}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    style={styles.btnPrimary}
                    onClick={this.handleConfirm}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "translateY(-1px)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "translateY(0)";
                    }}
                  >
                    <i className="fa fa-cog" style={{ fontSize: "12px" }}></i>{" "}
                    Go to Settings
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}

export default withRouter(PaymentButtons);
